import * as types from './types';

const initialState = {
  status: 'IDLE',
  id: 'unknown',
  projectName: 'unknown',
  stockPrice: 0,
  valuation: 0,
  taxRate: {},
  amount: 500,
  escrowAccount: null,
  amountSought: 0,
  name: '',
  legal_name: '',
  domain: '',
  projectPage: '',
  directlyInSociety: false,
  inCharge: '',
  inChargeCalendar: '',
  minAmount: 0,
  minPeaAmount: 0,
  pea: window.sessionStorage.getItem('pea') !== null && window.sessionStorage.getItem('pea') === 'true',
  transfer: undefined,
};

type InvestmentAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.InvestmentState>;
};

export default function investmentsReducer(state = initialState, action: InvestmentAction) {
  const { type, payload } = action;

  switch (type) {
    case 'FETCH_INVESTMENTS_DATA':
      return {
        ...state,
        ...payload,
        status: 'SUCCESS'
      };
    case 'UPDATE_AMOUNT':
      return { ...state, amount: payload };
    case 'UPDATE_PEA':
      return { ...state, pea: payload };
    case 'UPDATE_PROJECT_ID':
      return { ...state, id: payload };
    case 'MAKE_PAYMENT_SUCCESS':
      return {
        ...state,
        transfer: payload
      };
    default:
      return { ...state };
  }
}
